
import { defineComponent, Suspense } from 'vue'
import SuccessCard from './components/Card.vue'

export default defineComponent({
  name: 'Success',
  components: { SuccessCard },
  setup() {
    return { Suspense }
  },
})
